import BaseAddressImport from '@/views/BaseAddressImport.vue'

let routes = {
    path: '/base-address-import',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/base-address-import',
            name: 'base-address-import',
            component: BaseAddressImport,
            meta: {
                pageTitle: 'Importar Endereços de Base',
                breadcrumb: [
                    { text: 'Importar Endereços de Base', active: true },
                ],
            },
        }
    ]
};

export default routes



